import { createAppTheme } from '../../contexts/ThemeContext'

// The dark theme as a static instance, for tests and callers outside the provider
const theme = createAppTheme('dark')

export default theme
